import { combineReducers } from 'redux';
import sidebarReducer from './sidebar';
import loginUserDataReducer from './loginUserData';
import socketDataReducer from './socketData';
import headerReducer from './header';
import tabletNavHeaderReducer from './tabletNavHeader';
import tabletNavSidebarReducer from './tabletNavSidebar';
import tabletOptionReducer from './tabletOption';
import deliveryReducer from './delivery';
import permissionReducer from './permission';
import custombarReducer from './customBar';
import inquiriesItemReducer from './inquiriesItem';
import inquiriesStateReducer from './inquiriesState';
import modalReducer from './modal';

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  custombar: custombarReducer,
  header: headerReducer,
  loginUserData: loginUserDataReducer,
  socketData: socketDataReducer,
  tabletNavHeader: tabletNavHeaderReducer,
  tabletNavSidebar: tabletNavSidebarReducer,
  tabletOption: tabletOptionReducer,
  delivery: deliveryReducer,
  permission: permissionReducer,
  inquiriesItem: inquiriesItemReducer,
  inquiriesState: inquiriesStateReducer,
  modal: modalReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
